// extracted by mini-css-extract-plugin
export default {"SchemaItems":"SchemaItems3trsGJTKh8vi"};